import { PersonType, toEnumType } from '../enums/PersonType';
import { type AddressDto } from './Address';
import { type BankDto } from './BankDto';
import { type AttachmentDto } from './AttachmentDto';
import { type EnumType } from './EnumType';
import { type NotificationHasUserDto } from './NotificationHasUserDto';
import { type PersonOfContactDto } from './PersonOfContactDto';
import { type UserDto } from './UserDto';

export enum ContactType {
  CLIENT = 'CLIENT',
  SUPPLIER = 'SUPPLIER',
  ACQUIRER = 'ACQUIRER',
  SYSTEM_USER = 'SYSTEM_USER',
  COMMUNITY = 'COMMUNITY',
  ACCOUNTANT = 'ACCOUNTANT',
  ADMIN = 'ADMIN',
}

export enum ContactLocalType {
  RESIDENTIAL_HOUSES,
  RESIDENTIAL_APARTMENTS,
  INDUSTRIAL_BUSINESS,
  OFFICE_BUSINESS,
  HOSPITAL_BUSINESS,
  UNIVERSITY_BUSINESS,
}

export type ContactDto = {
  id?: string;
  name: string;
  phone?: string;
  email?: string;
  registration_date?: string;
  modification_date?: string;
  active?: boolean;
  type?: EnumType;
  cpf?: string;
  cnpj?: string;
  birth_date?: string;
  rg?: string;
  company_name?: string;
  role?: string;
  admission_date?: string;
  pis?: string;
  ctps?: string;
  salary?: number;
  code?: string;
  address?: AddressDto;
  image?: AttachmentDto;
  notifications?: NotificationHasUserDto[];
  local_type?: EnumType;
  surname?: string;
  cell_phone?: string;
  business_email?: string;
  users?: UserDto[];
  persons_of_contact?: PersonOfContactDto[];
  number_of_residents?: number;
  website?: string;
  payment_condition?: string;
  credit_limit?: number;
  notes?: string;
  gender?: EnumType;
  attachments?: AttachmentDto[];
  sector?: string;
  person_type?: EnumType;
  state_registration?: string;
  municipal_registration?: string;
  contributor_type?: EnumType;
  // Acordo financeiro da comunidade (issue #732 / API #865). O backend grava como veio: null apaga,
  // por isso o form manda o objeto inteiro e limpa com null — ver core/_utils.ts.
  cashback_type?: EnumType | null;
  cashback_value?: number | null;
  cashback_minimum?: number | null;
  cashback_maximum?: number | null;
  energy_charge_type?: EnumType | null;
  energy_value?: number | null;
  payment_day?: number | null;
  transfer_method?: EnumType | null;
  bank?: BankDto | null;
  agency?: string | null;
  agency_digit?: string | null;
  account?: string | null;
  account_digit?: string | null;
  bank_account_type?: EnumType | null;
  pix_type?: EnumType | null;
  pix_key?: string | null;
  beneficiary_name?: string | null;
  beneficiary_document?: string | null;
  partnership_start_date?: string | null;
  exemption_months?: number | null;
  partnership_end_date?: string | null;
  notice_period_days?: number | null;
  adjustment_index?: EnumType | null;
  adjustment_month?: number | null;
};

export const initialCommunityContactDtoEmpty: ContactDto = {
  id: '',
  name: '',
  phone: '',
  email: '',
  active: true,
  type: undefined,
  cnpj: '',
  company_name: '',
  code: '',
  address: {
    street: '',
    neighborhood: '',
    complement: '',
    city: '',
    number: '',
  },
  image: undefined,
  users: [],
  cell_phone: '',
  business_email: '',
  persons_of_contact: [],
  website: '',
  agency: '',
  agency_digit: '',
  account: '',
  account_digit: '',
  pix_key: '',
  beneficiary_name: '',
  beneficiary_document: '',
};

export const initialClientContactDtoEmpty: ContactDto = {
  name: '',
  phone: '',
  email: '',
  active: true,
  code: '',
  address: {
    street: '',
    neighborhood: '',
    complement: '',
    city: '',
    number: '',
  },
  image: undefined,
  users: [],
  website: '',
  persons_of_contact: [],
  person_type: toEnumType(PersonType.PHYSICAL),
  type: { value: 'CLIENT', description: '' },
  municipal_registration: '',
  state_registration: '',
  cpf: '',
  cnpj: '',
  rg: '',
  company_name: '',
  birth_date: '',
  admission_date: '',
  pis: '',
  ctps: '',
  salary: undefined,
  role: '',
};

export const initialUserPreferencesEmpty: ContactDto = {
  name: '',
  role: '',
  phone: '',
  persons_of_contact: [],
};
